/** When your routing table is too long, you can split it into small modules**/


export default [{
        path: '/talabbos-request',
        name: 'talabbosRequest',
        component: () =>
            import ('@/views/talabbos/Request'),
    },
    {
        path: '/talabbos-index',
        name: 'talabbosIndex',
        component: () =>
            import ('@/views/talabbos/Index'),
    },
    {
        path: '/talabbos-history',
        name: 'talabbosHistory',
        component: () =>
            import ('@/views/talabbos/History'),
    },
    {
        path: '/talabbos-confirm',
        name: 'talabbosConfirm',
        component: () =>
            import ('@/views/talabbos/Confirm'),
    }


]